import ModalBase, { ModalBaseProps } from '~components/ModalBase';

import ChartContents from '../ChartContents';
import * as S from './style';

export default function ModalCultureReview({ isOpen, handleClose }: ModalBaseProps) {
  return (
    <ModalBase
      isOpen={isOpen}
      handleClose={handleClose}
      hasCloseButton
      maskClosable
      verticalAlign='center'
      inlineCss={S.cssModal}>
      <S.Wrapper>
        <S.Title>조직문화</S.Title>
        <S.ScrollableContents>
          <ChartContents />
        </S.ScrollableContents>
      </S.Wrapper>
    </ModalBase>
  );
}
